import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import logo from '../Images/logo2.png';


export default function Header() {
    return (
        <div>
            {/* Navbar */}
            <Navbar expand="lg" bg="light" sticky="top" className="shadow-sm py-3">
                <Container>
                    <Navbar.Brand
                        as={Link}
                        to="/"
                        className="fw-bold fs-3 text-danger text-uppercase d-flex align-items-center gap-2"

                    >
                        <img
                            src={logo}
                            alt="Logo"
                            className="nav-logo"
                        />
                        Akul Creations
                    </Navbar.Brand>


                    <Navbar.Toggle aria-controls="navbar-nav" />
                    <Navbar.Collapse id="navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            <Nav.Link as={Link} to="/" className="nav-item-custom">Home</Nav.Link>
                            <Nav.Link as={Link} to="/Aboutus" className="nav-item-custom">About Us</Nav.Link>
                            <Nav.Link as={Link} to="/collection" className="nav-item-custom">Collection</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className="nav-item-custom">Contact Us</Nav.Link>
                            {/* <Nav.Link as={Link} to="/TrackOrder" className="nav-item-custom">TrackOrder</Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}
